import React from 'react';
import { User } from 'lucide-react';
export function About() {
  const skills = ['User Research', 'Wireframing', 'Prototyping', 'Design Systems', 'Usability Testing', 'Information Architecture', 'Figma', 'Framer'];
  return <section id="about" className="py-24 md:py-32 px-6 md:px-12 max-w-7xl mx-auto border-t border-border/50" data-id="element-1">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-center" data-id="element-2">
        {/* Image Side */}
        <div className="lg:col-span-5 order-2 lg:order-1" data-id="element-3">
          <div className="w-full aspect-[4/5] bg-card-bg rounded-2xl flex flex-col items-center justify-center text-text-muted border border-border relative overflow-hidden" data-id="element-4">
            <div className="absolute inset-0 bg-gradient-to-tr from-bg/50 to-transparent z-10" data-id="element-5"></div>
            <User size={64} strokeWidth={1} className="mb-4 opacity-50" data-id="element-6" />
            <span className="text-sm font-medium tracking-widest uppercase opacity-50" data-id="element-7">
              Portrait Placeholder
            </span>
          </div>
        </div>

        {/* Content Side */}
        <div className="lg:col-span-7 order-1 lg:order-2" data-id="element-8">
          <h2 className="font-serif text-4xl md:text-5xl text-text mb-8" data-id="element-9">
            About Me
          </h2>

          <div className="space-y-6 font-sans text-lg text-text-muted leading-relaxed mb-12" data-id="element-10">
            <p data-id="element-11">
              With over 8 years of experience in product design, I specialize in
              translating complex business requirements into elegant, intuitive
              user experiences. My background spans across healthcare, fintech,
              and enterprise SaaS.
            </p>
            <p data-id="element-12">
              I believe that great design is rooted in deep empathy and rigorous
              systems thinking. I'm passionate about conducting generative user
              research to uncover real problems, and then building scalable
              design systems to solve them efficiently.
            </p>
            <p data-id="element-13">
              When I'm not pushing pixels or interviewing users, you can find me
              exploring local coffee shops, reading sci-fi novels, or trying to
              keep my houseplants alive.
            </p>
          </div>

          <div data-id="element-14">
            <h3 className="font-sans text-sm font-bold uppercase tracking-wider text-text mb-6" data-id="element-15">
              Skills & Tools
            </h3>
            <div className="flex flex-wrap gap-3" data-id="element-16">
              {skills.map(skill => <span key={skill} className="px-4 py-2 bg-bg border border-border rounded-full text-sm font-medium text-text-muted" data-id="element-17">
                  {skill}
                </span>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}